<template>
    <g id="clock">
      <circle class="cls-57" cx="1010.5" cy="144.3" r="44"/>
      <circle class="cls-52" cx="1010.5" cy="144.3" r="38.7"/>
      <g class="cls-58">
        <g class="cls-38">
          <g class="cls-59">
            <use transform="matrix(0.04, -0.07, 0.1, 0.06, 929.09, 162.39)" xlink:href="#image-2"/>
          </g>
        </g>
      </g>
      <line id="seconds" class="cls-60" x1="1010.5" y1="146.3" x2="1010.5" y2="111.1"  v-bind:style="{transform: 'rotate(' + seconds + 'deg)'}"/>
      <line id="minutes" class="cls-61" x1="1010.5" y1="146.3" x2="1010.5" y2="114.5" v-bind:style="{transform: 'rotate(' + minutes + 'deg)'}"/>
      <line id="hours" class="cls-62" x1="1010.5" y1="146.3" x2="1010.5" y2="118.3"  v-bind:style="{transform: 'rotate(' + hours + 'deg)'}"/>
    </g>	
</template>
<script>
export default {
	name: 'clock',
	data () {
		return {
		  minutes : 0,
		  seconds: 0,
		  hours: 0,
		}
	},
	methods: { 
		calculateTime () {
		  	var d = new Date();
		  	var minutesDeg = parseInt(d.getMinutes()) * 6;
		  	var secondsDeg = parseInt(d.getSeconds()) * 6;
		  	var hours_ = d.getHours() % 12 || 12;
		  	var hoursDeg = hours_ * 30;
		  	if(minutesDeg >= 360 ) { minutesDeg = 0; }
		  	if(secondsDeg >= 360 ) { secondsDeg = 0; }
		    this.minutes = minutesDeg;
		    this.seconds = secondsDeg;
		    this.hours = hoursDeg;
		}
	},
	mounted: function () {
		setInterval( () => { 
			this.calculateTime();
		 }, 1000)
	}
}	
</script>



// WEBPACK FOOTER //
// Clock.vue?643733a5